'use strict';

// Shim so that _interopRequireDefault(require("axios")) in
// @els/els-ui-common-react compiled output gets a callable .default.
//
// The 'axios$' alias (exact match only) redirects require("axios") here.
// require("axios/dist/...") sub-paths are NOT matched by the $ alias
// so this line resolves normally through node_modules.
//
// Setting __esModule:true makes _interopRequireDefault return this module
// as-is; .default is the callable function (set by axios.cjs itself).
const axios = require('axios/dist/browser/axios.cjs');
module.exports = axios;
module.exports.__esModule = true;